export interface ServiceVersionMap {
  default?: string;
  [service: string]: string | undefined;
}

export interface Config {
  baseUrl: string;
  serviceVersion?: ServiceVersionMap;
  [key: string]: any;
}

const config: Config = {
  baseUrl: '/services',
};

export default config;
